import React, { useCallback, useEffect, useState } from 'react';
import GeoJSONMap from './GeoJSONMap';
import HearsayForm from './components/HearsayForm';
import './App.css';

function App() {
  const [geojsonData, setGeojsonData] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [activeView, setActiveView] = useState('map');
  const [loadingMap, setLoadingMap] = useState(true);
  const [mapError, setMapError] = useState('');

  const fetchHistoricalData = useCallback(async () => {
    setLoadingMap(true);
    setMapError('');
    try {
      const response = await fetch('/api/historical/');
      if (!response.ok) {
        throw new Error('Unable to load map data right now.');
      }
      const data = await response.json();
      setGeojsonData(data);
    } catch (error) {
      console.error('Error fetching data:', error);
      setMapError(error.message || 'Unable to load map data.');
    } finally {
      setLoadingMap(false);
    }
  }, []);

  useEffect(() => {
    fetchHistoricalData();
  }, [fetchHistoricalData]);


  return (
    <div className="App">
      <div className="clearfix titlebar">
        <h1 className="site-title">
          the names of places
        </h1>
      </div>
      <div className="view-toggle-wrap">
        <nav className="view-toggle" aria-label="Primary view switcher">
          <button
            type="button"
            className={activeView === 'map' ? 'active' : ''}
            onClick={() => setActiveView('map')}
          >
            Map view
          </button>
          <button
            type="button"
            className={activeView === 'hearsay' ? 'active' : ''}
            onClick={() => setActiveView('hearsay')}
          >
            Share hearsay data
          </button>
        </nav>
      </div>
      <main>
        {activeView === 'map' && loadingMap && (
          <p className="status-message">Loading map data...</p>
        )}
        {activeView === 'map' && mapError && (
          <p className="status-message error">{mapError}</p>
        )}
        {activeView === 'map' && geojsonData && !loadingMap && (
          <GeoJSONMap
            geoJSONData={geojsonData}
            onCoordinateSelect={setSelectedLocation}
          />
        )}
        {activeView === 'hearsay' && (
          <HearsayForm selectedLocation={selectedLocation} />
        )}
      </main>
    </div>
  );
}

export default App;
